import React from "react";

import Listbox from "../Generics/Controls/Listbox.jsx";
export default function StateCountrySelector({
	onChangeCountry = () => console.warn("No handler set for this"),
	onChangeState = () => console.warn("No handler set for this"),
	stateItems = [],
	stateValue = { id: "", name: "All States" },
	countryItems = [],
	countryValue = { id: "", name: "All Countries" },
	defaultState = { id: "", name: "All States" },
}) {
	console.log("state items", stateItems);
	const countryClasses = countryValue.id ? "border-r border-gray-400 flex-1" : "relative flex-1";
	return (
		<div className="relative flex flex-2">
			<Listbox
				className={countryClasses}
				selected={countryValue}
				items={countryItems}
				onChange={onChangeCountry}
			/>
			{countryValue.id ? (
				<Listbox
					className="relative flex-1"
					selected={stateValue}
					items={stateItems[countryValue.id]}
					onChange={onChangeState}
				/>
			) : null}
		</div>
	);
}
